import comp from "./SelectionModal";
export default comp;
